import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFactor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.8 8C4.8 9.7648 6.2352 11.2 8 11.2C9.4088 11.2 10.5936 10.2792 11.02 9.0128L12.7992 7.98L12.8 8C12.8 10.6512 10.6512 12.8 8 12.8C5.3488 12.8 3.2 10.6512 3.2 8C3.2 5.3488 5.3488 3.2 8 3.2C8.8672 3.2 9.6784 3.4336 10.38 3.8352L8.612 4.8616C8.4136 4.8232 8.2096 4.8 8 4.8C6.2352 4.8 4.8 6.2352 4.8 8ZM8 6.4C7.116 6.4 6.4 7.1168 6.4 8C6.4 8.8832 7.116 9.6 8 9.6C8.884 9.6 9.6 8.8832 9.6 8L9.5984 7.988L12.2864 6.428C13.0672 5.976 14.4496 6.1592 15.2552 6.5552L19.2 4.2648L16.6736 3.0096L16.8088 0.104L12.8528 2.4C12.7968 3.2968 12.2656 4.5888 11.4888 5.0408L8.7824 6.612C8.5504 6.4816 8.2856 6.4 8 6.4ZM14.396 7.9288L14.4 8C14.4 11.5288 11.5288 14.4 8 14.4C4.4712 14.4 1.6 11.5288 1.6 8C1.6 4.4712 4.4712 1.6 8 1.6C9.18 1.6 10.2824 1.9264 11.2328 2.4856C11.5 2.0168 11.5752 1.2504 11.3496 0.7416C10.3296 0.2704 9.1976 0 8 0C3.5816 0 0 3.5816 0 8C0 12.4184 3.5816 16 8 16C12.1864 16 15.6168 12.7832 15.9656 8.6864C15.7248 8.3 15.1128 7.8376 14.396 7.9288Z",
		fill: "#4F4F4F"
	})
});
export default SvgFactor;
